// extracted by mini-css-extract-plugin
export var arrows = "_5b-5";
export var decrementer = "_5b-9";
export var disabled = "_5b-3";
export var error = "_5b-1";
export var hiddenText = "_5b-a";
export var incrementer = "_5b-8";
export var input = "_5b-7";
export var inputWrapper = "_5b-0";
export var leadingIcon = "_5b-b";
export var readonly = "_5b-2";
export var regular = "_5b-6";
export var small = "_5b-4";